import Icon, { Icons } from '@/presentation/components/elements/Icon';
import { IconSizes } from '@/presentation/components/elements/Icon/Icon';

export const SidebarHorizontalLinkIcon = ({
  icon,
  isActive,
  className,
  iconSize,
}: {
  icon: Icons;
  isActive: boolean;
  className?: string;
  iconSize?: IconSizes;
}) => {
  return (
    <Icon
      name={icon}
      size={iconSize || 20}
      className={`${className} transition-all transform flex-none min-w-0 transition-colors
          ${
            isActive
              ? 'text-orange-500'
              : 'text-gray-400 group-hover:text-gray-500'
          }
        `}
    />
  );
};
